import React from 'react'
import LogoMappy from './logo-mappy.svg'
import s from './LogoMappyImg.less'

const LogoMappyImg = () => <img className={s.logo} width="87" height="19" src={LogoMappy} alt="Mappy" loading="lazy" />

export default LogoMappyImg
